import { FormCheckboxGroup } from '@pm/forms';
import { type QuestionnaireCheckboxQuestion as GQLQuestionnaireCheckboxQuestion } from '@pm/graphql';
import { MultiSelect, QuestionnaireMarkdown } from '@pm/ui';
import { CardText } from '../CardText';
import { HookFormCheckbox } from '../Checkbox/HookFormCheckbox';
import { QuestionnaireSection } from './QuestionnaireSection';

type QuestionnaireCheckboxQuestionProps = GQLQuestionnaireCheckboxQuestion;

export const QuestionnaireCheckboxQuestion = ({
  id,
  title,
  description,
  acceptableAnswers = [],
}: QuestionnaireCheckboxQuestionProps) => {
  const options = acceptableAnswers.map((answer) => ({
    text: answer.label,
    value: answer.value ?? answer.label,
  }));

  const multiSelectOptions = acceptableAnswers.map((answer) => {
    const optionParts = answer.label.split(/\n(.*)/s);
    const hasHeaderAndBody = optionParts.length > 1;

    return {
      header: hasHeaderAndBody ? optionParts[0] : '',
      body: hasHeaderAndBody ? optionParts[1] : optionParts[0],
      value: answer.value ?? '',
    };
  });

  const freeTextValue = acceptableAnswers.find(
    (answer) => answer.value === null,
  )?.label;

  const noneValue = acceptableAnswers.find(
    (answer) => answer.value?.toLocaleLowerCase() === 'none',
  )?.value;

  return (
    <QuestionnaireSection>
      <CardText className="text-grey-900 text-xl">{title}</CardText>
      {description && (
        <CardText>
          <QuestionnaireMarkdown>{description}</QuestionnaireMarkdown>
        </CardText>
      )}
      {options.length === 1 ? (
        <HookFormCheckbox name={id} value={options[0].value}>
          {options[0].text}
        </HookFormCheckbox>
      ) : (
        <FormCheckboxGroup
          name={id}
          options={multiSelectOptions}
          CheckboxComponent={MultiSelect}
          noneValue={noneValue}
          freeText={{
            on: freeTextValue ?? '',
            name: id,
          }}
        />
      )}
    </QuestionnaireSection>
  );
};
